// Tier-specific gradient colors for the progress indicator
export const TIER_GRADIENTS = {
  Member: {
    start: "color-mix(in srgb, #fff 70%, #8b8b8b)",
    end: "#8b8b8b",
  },
  "Silver Elite": {
    start: "color-mix(in srgb, #fff 70%, #575b6e)",
    end: "#575b6e",
  },
  "Gold Elite": {
    start: "color-mix(in srgb, #fff 70%, #6f4818)",
    end: "#6f4818",
  },
  "Platinum Elite": {
    start: "color-mix(in srgb, #fff 70%, #43454a)",
    end: "#43454a",
  },
  "Titanium Elite": {
    start: "color-mix(in srgb, #fff 70%, #342829)",
    end: "#342829",
  },
  "Ambassador Elite": {
    start: "color-mix(in srgb, #fff 70%, #231c19)",
    end: "#231c19",
  },
};

// Default fallback gradient
const DEFAULT_GRADIENT = TIER_GRADIENTS["Silver Elite"];

/**
 * Get the gradient colors for a specific tier
 * @param {string} tierName - The tier name (e.g., "Gold Elite")
 * @returns {{ start: string, end: string }} The gradient colors
 */
export const getTierGradient = (tierName) => {
  return TIER_GRADIENTS[tierName] || DEFAULT_GRADIENT;
};

// Default benefits shown for all tiers
export const DEFAULT_TIER_BENEFITS = [
  { icon: "clock", text: "Priority Late Checkout" },
  { icon: "star", text: "10% Bonus Points" },
  { icon: "tag", text: "Member-Only Rates" },
  { icon: "wifi", text: "Free Wi-Fi" },
];

// Tier-specific benefits (can be expanded as needed)
export const TIER_BENEFITS = {
  Member: [
    { icon: "tag", text: "Member-Only Rates" },
    { icon: "wifi", text: "Free Wi-Fi" },
    { icon: "mobile", text: "Mobile Check-In" },
  ],
  "Silver Elite": [
    { icon: "star", text: "Get 10% More Points" },
    { icon: "clock", text: "Priority Late Checkout" },
    { icon: "tag", text: "Member Rates & Complimentary WiFi" },
  ],
  "Gold Elite": [
    { icon: "star", text: "Get 25% More Points" },
    { icon: "upgrade", text: "Enhanced Room Upgrades" },
    { icon: "wifi", text: "Free Enhanced Wi-Fi" },
  ],
  "Platinum Elite": [
    { icon: "star", text: "Get 50% More Points" },
    { icon: "upgrade", text: "Enhanced Room Upgrades" },
    { icon: "gift", text: "Welcome Gift Choice" },
  ],
  "Titanium Elite": [
    { icon: "clock", text: "4 PM Late Checkout" },
    { icon: "star", text: "75% Bonus Points" },
    { icon: "lounge", text: "Lounge Access" },
    { icon: "gift", text: "Annual Choice Benefit" },
  ],
  "Ambassador Elite": [
    { icon: "concierge", text: "Ambassador Service" },
    { icon: "star", text: "75% Bonus Points" },
    { icon: "upgrade", text: "Your24 Flexible Check-In" },
    { icon: "gift", text: "Annual Choice Benefit" },
  ],
};

/**
 * Get the benefits for a specific tier
 * @param {string} tierName - The tier name (e.g., "Gold Elite")
 * @returns {Array<{ icon: string, text: string }>} The benefits for the tier
 */
export const getTierBenefits = (tierName) => {
  return TIER_BENEFITS[tierName] || DEFAULT_TIER_BENEFITS;
};
